import React from 'react';
import TabLinkUI from '../../../widgets/output/TabLinkUI';

const PendingMessageApprovalListNavI = ({ context, page }) =>
  <div>
    <div className='g_flex_h g_flex_left g_flex_wrap'>
      <TabLinkUI
        label='Notice'
        to={`/su/messageApprovals`}
        active={page === 'messageApprovals'}
      />
      <TabLinkUI
        label='Whatsapp Message'
        to={`/su/messageApprovals/whatsapp`}
        active={page === 'messageApprovals_whatsapp'}
      />
     <TabLinkUI
            label='Email Message'
            to={`/su/messageApprovals/email`}
            active={page === 'messageApprovals_email'}
     />
    </div>
    <div className='g_m_top_50' />
  </div>

export default PendingMessageApprovalListNavI
